import React from "react";
import { Link } from "react-router-dom";
import { Phone, Printer, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_SERVICES } from "../lib/site";
import { ClientPortalLink } from "./ClientPortalLink";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-black text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center bg-brand-red font-extrabold text-white">M</span>
              <span className="text-lg font-extrabold tracking-tight">MJG<span className="text-brand-red">.</span> Promotions</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
              {COMPANY.tagline}
            </p>
            <div className="mt-6 space-y-3 text-sm text-white/80">
              <p className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" />
                <span>{COMPANY.addressLine1}<br />{COMPANY.addressLine2}</span>
              </p>
              <a href={COMPANY.phoneHref} className="flex items-center gap-2.5 hover:text-white" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-brand-red" aria-hidden="true" /> {COMPANY.phone}
              </a>
              <p className="flex items-center gap-2.5">
                <Printer className="h-4 w-4 text-brand-red" aria-hidden="true" /> Fax {COMPANY.fax}
              </p>
              <a href={COMPANY.emailHref} className="flex items-center gap-2.5 hover:text-white" data-testid="footer-email">
                <Mail className="h-4 w-4 text-brand-red" aria-hidden="true" /> {COMPANY.email}
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Services</h3>
            <ul className="mt-5 space-y-3 text-sm">
              {NAV_SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={s.slug} className="text-white/75 transition-colors hover:text-brand-red" data-testid={`footer-link${s.slug}`}>
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white/40">Company</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/about" className="text-white/75 hover:text-brand-red" data-testid="footer-about">About</Link></li>
              <li><Link to="/contact" className="text-white/75 hover:text-brand-red" data-testid="footer-contact">Contact</Link></li>
              <li>
                <ClientPortalLink testId="footer-portal" showIcon className="inline-flex items-center text-white/75 hover:text-brand-red">
                  Client Portal
                </ClientPortalLink>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-7 inline-flex items-center bg-brand-red px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-brand-redhover"
              data-testid="footer-cta"
            >
              Request a Consultation
            </Link>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {COMPANY.name}. All rights reserved.</p>
          <div className="flex flex-wrap gap-5">
            <Link to="/privacy-policy" className="transition-colors hover:text-white/80" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/accessibility" className="transition-colors hover:text-white/80" data-testid="footer-accessibility">Accessibility Statement</Link>
            <Link to="/terms" className="transition-colors hover:text-white/80" data-testid="footer-terms">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
